import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { API_URL, API_BOW_URL } from "./../config";

function getStoredAccessToken() {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) return null;

  try {
    return JSON.parse(accessToken);
  } catch {
    return accessToken;
  }
}

function getAuthData() {
  const accessToken = getStoredAccessToken();
  if (!accessToken) throw new Error("No access token found");

  const decoded = jwtDecode(accessToken);
  return {
    token: accessToken,
    id: decoded?.id,
    hospitalId: decoded?.hospitalId || null,
    roleId: decoded?.roleId || 1,
  };
}

function authJsonHeaders() {
  const accessToken = getStoredAccessToken();

  return {
    "Content-Type": "application/json",
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

// Auth
export const login = (payload) => {
  return axios.post(`${API_URL}/auth/login`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const loginBow = (payload) => {
  return axios.post(`${API_BOW_URL}/api/auth/login/`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const register = (payload) => {
  return axios.post(`${API_URL}/auth/register`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

// Users
export const getUser = () => {
  const { roleId, id, hospitalId } = getAuthData();

  return axios.get(`${API_URL}/users?hospitalId=${hospitalId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const getUserDetail = () => {
  const { hospitalId, id } = getAuthData();

  return axios.get(`${API_URL}/users/user/detail`, {
    params: {
      hospitalId,
      userId: id,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getUserById = (id) => {
  const { hospitalId: authHospitalId } = getAuthData();

  return axios.get(`${API_URL}/users/user/detail`, {
    params: {
      hospitalId: authHospitalId,
      userId: id,
    },
  });
};
export const getUserByIdwithHospitalId = ({ id, hospitalId }) => {
  const { hospitalId: authHospitalId } = getAuthData();

  return axios.get(`${API_URL}/users/user/detail`, {
    params: {
      hospitalId: hospitalId || authHospitalId,
      userId: id,
    },
  });
};
export const createUser = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(
    `${API_URL}/users`,
    { ...payload, shopId: shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const deleteUser = ({ id, hospitalId }) => {
  const { hospitalId: authHospitalId } = getAuthData();

  return axios.delete(
    `${API_URL}/users/${hospitalId || authHospitalId}/${id}`,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const updateUser = ({ id, hospitalId }, payload) => {
  const { hospitalId: authHospitalId } = getAuthData();

  return axios.put(
    `${API_URL}/users/${hospitalId || authHospitalId}/${id}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const resetPassword = (username, password) => {
  const { shopId } = getAuthData();

  return axios.put(
    `${API_URL}/users/reset_password/${shopId}`,
    { username, password },
    {
      headers: {
        "Content-Type": "application/json",
        // "Authorization": "Bearer " + token,
      },
    },
  );
};
export const getPetBowById = (id) => {
  const BowAccessToken = localStorage.getItem("bow_accessToken");
  return axios.get(`${API_BOW_URL}/api/pets/${id}?all=true`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + BowAccessToken,
    },
  });
};
export const getPetById = (id) => {
  return axios.get(`${API_URL}/pets/${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const getPetHistoryById = (id) => {
  return axios.get(`${API_URL}/pet-treatment?id=${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const createPet = (payload) => {
  // const BowAccessToken = localStorage.getItem("accessToken");
  return axios.post(`${API_URL}/pets/create`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const createTreatments = (payload) => {
  // const BowAccessToken = localStorage.getItem("accessToken");
  return axios.post(`${API_URL}/pets`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const putVaccineRecordsBow = (payload) => {
  const BowAccessToken = localStorage.getItem("bow_accessToken");
  return axios.post(`${API_BOW_URL}/api/vaccine-records/`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + BowAccessToken,
    },
  });
};
export const putMicrochipRecordsBow = (payload) => {
  const BowAccessToken = localStorage.getItem("bow_accessToken");
  return axios.patch(
    `${API_BOW_URL}/api/pets/${payload.id}/?all=true`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + BowAccessToken,
      },
    },
  );
};
export const createParasiteRecordsBow = (payload) => {
  const BowAccessToken = localStorage.getItem("bow_accessToken");
  return axios.post(`${API_BOW_URL}/api/parasite-records/`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + BowAccessToken,
    },
  });
};
export const getHistory = () => {
  const { roleId, id, hospitalId } = getAuthData();

  const query = `hospitalId=${hospitalId}`;

  return axios.get(`${API_URL}/pet-treatment?${query}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const getPets = () => {
  const { roleId, id, hospitalId } = getAuthData();
  return axios.get(`${API_URL}/hospital/pets/${hospitalId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const getPetsBykeyword = (keyword) => {
  const { roleId, id, hospitalId } = getAuthData();
  return axios.get(
    `${API_URL}/hospital/pets/search?keyword=${keyword}&hospitalId=${hospitalId}`,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};
export const uploadImage = (file, type) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("key", type);
  return axios.post(`${API_URL}/files`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getHospitalList = () => {
  return axios.get(`${API_URL}/users/hospital/list`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};

export const createOwner = (owners) => {
  const { roleId, id, hospitalId } = getAuthData();
  return axios.post(
    `${API_URL}/hospital/owners`,
    { ...owners, hospitalId: hospitalId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + BowAccessToken
      },
    },
  );
};

export const getOwnersByHospital = () => {
  const { roleId, id, hospitalId } = getAuthData();

  return axios.get(`${API_URL}/hospital/owners/${hospitalId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const updatePetOwner = (petId, owner) => {
  return axios.put(`${API_URL}/hospital/pets/${petId}/owner`, owner, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const getCertificate = (petId) => {
  return axios.get(`${API_URL}/hospital/pets_form/${petId}/owner-form-pdf`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};

export const getOwnerById = (ownerId) => {
  return axios.get(`${API_URL}/hospital/owner/${ownerId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateOwner = (ownerId, payload) => {
  return axios.put(`${API_URL}/hospital/owner/${ownerId}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const checkPetLink = (payload) => {
  const { hospitalId } = getAuthData();

  return axios.post(
    `${API_URL}/pet-links/check`,
    {
      ...payload,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const LinkPet = (payload) => {
  const { hospitalId } = getAuthData();
  return axios.post(`${API_URL}/pet-links`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const getPetLinksByStatus = (status) => {
  const { hospitalId } = getAuthData();
  const payload = {
    hospitalId: String(hospitalId),
    status: status || "ALL",
  };
  return axios.get(`${API_URL}/pet-links/`, {
    params: payload,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getPetLinks = () => {
  const { hospitalId } = getAuthData();
  const payload = {
    role: "HOSPITAL",
    hospitalId: String(hospitalId),
  };
  return axios.post(`${API_URL}/pet-links/pending`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updatePetLinkStatus = (id) => {
  const { hospitalId } = getAuthData();
  const payload = {
    role: "HOSPITAL",
    hospitalId: String(hospitalId),
  };
  return axios.post(`${API_URL}/pet-links/${id}/accept`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateUserStatus = (id, payload) => {
  const { hospitalId } = getAuthData();

  return axios.put(`${API_URL}/users/${hospitalId}/${id}/status`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getMyProfile = () => {
  return axios.get(`${API_URL}/users/profile`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateProfile = (payload) => {
  return axios.put(`${API_URL}/users/profile`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getHospitalByUser = (userId) => {
  return axios.get(`${API_URL}/hospital/user/${userId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateHospitalByUser = (userId, data) => {
  return axios.put(`${API_URL}/hospital/user/${userId}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// =============================
// 🔥 SUPER ADMIN - HOSPITAL
// =============================

// 📄 list โรงพยาบาล
export const getHospitals = () => {
  return axios.get(`${API_URL}/hospital`, {
    headers: authJsonHeaders(),
  });
};

// 🔍 detail โรงพยาบาล
export const getHospitalById = (id) => {
  return axios.get(`${API_URL}/hospital/${id}`, {
    headers: authJsonHeaders(),
  });
};

// ➕ create โรงพยาบาล
export const createHospital = (payload) => {
  return axios.post(`${API_URL}/hospital`, payload, {
    headers: authJsonHeaders(),
  });
};

// ✏️ update โรงพยาบาล
export const updateHospital = (id, payload) => {
  return axios.put(`${API_URL}/hospital/${id}`, payload, {
    headers: authJsonHeaders(),
  });
};
export const getCombinedRecords = (pet_id) => {
  return axios.get(`${API_BOW_URL}/api/combined-records/public/${pet_id}/`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 🔄 toggle เปิด/ปิด
export const toggleHospital = (id) => {
  return axios.put(
    `${API_URL}/hospital/${id}/toggle`,
    {},
    {
      headers: authJsonHeaders(),
    },
  );
};

// 🗑 delete (soft delete / disable)
export const deleteHospital = (id) => {
  return axios.delete(`${API_URL}/hospital/${id}`, {
    headers: authJsonHeaders(),
  });
};

export const forgotPassword = (data) => {
  return axios.post(`${API_URL}/auth/forgot-password`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const resetPasswordWithEmail = (data) => {
  return axios.post(`${API_URL}/auth/reset-password`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const changePassword = (data) => {
  return axios.post(`${API_URL}/auth/change-password`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getUserByHospital = (hospitalId) => {
  return axios.get(`${API_URL}/users/by-hospital/${hospitalId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateUserRole = (userId, role) => {
  return axios.put(`${API_URL}/users/role/${userId}`, {
    role,
  });
};

export const createAppointmentBow = (payload) => {
  const BowAccessToken = localStorage.getItem("bow_accessToken");

  return axios.post(`${API_BOW_URL}/api/appointments/`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + BowAccessToken,
    },
  });
};
